import { usePageContext } from "lib/context/page-context";
import { useCallback } from "react";
import { ChatbotBlock } from "../schema";
import { OpenAiUsage } from "../types";
import { useTrackingContext } from "observability";

export const useTrackOpenAiUsage = (config: ChatbotBlock["config"]) => {
  const { creator, isEmbedded, pageId, projectId } = usePageContext();
  const { emitChatbotAITokenUsageReceivedEvent } = useTrackingContext();

  return {
    trackOpenAiUsage: useCallback(
      ({ prompt_token_quantity, completion_token_quantity }: OpenAiUsage) => {
        if (creator && config.id && projectId && pageId) {
          emitChatbotAITokenUsageReceivedEvent({
            completion_token_quantity,
            current_project_owner_creator_id: creator.id,
            current_project_owner_customuser_id: creator.zapierId,
            current_project_owner_plan_type: creator.planId ? "paid" : "free",
            consumer_customuser_id: null,
            embedded_flag: isEmbedded,
            interfaces_component_id: config.id,
            interfaces_page_id: pageId,
            interfaces_project_id: projectId,
            model_name: config.model,
            authentication_id: config.authenticationId
              ? parseInt(config.authenticationId)
              : null,
            prompt_token_quantity,
            total_token_quantity:
              prompt_token_quantity + completion_token_quantity,
          });
        }
      },
      [
        creator,
        config.id,
        config.model,
        config.authenticationId,
        projectId,
        pageId,
        emitChatbotAITokenUsageReceivedEvent,
        isEmbedded,
      ]
    ),
  };
};
